











import mixins from 'vue-typed-mixins'
import actualitesMixins from './actualitesMixin'

export default mixins(actualitesMixins).extend({
    computed: {
        ScreenHeight() {
            return screen.height + "px";
        }
    }
})
